<div class="relative flex w-full flex-col">
	<div class="absolute inset-0 left-56 lg:left-64">
		<div class="h-px w-full bg-[#d9d9d9]"></div>
		<div class="flex h-full w-full justify-between">
			@for (line of range; track line) {
				<div class="relative h-full w-px bg-[#d9d9d9]">
					<div class="absolute -bottom-8 right-0 text-base font-medium text-[#212124]">{{ line }}</div>
				</div>
			}
		</div>
	</div>

	<!-- Ratings Bars -->
	<div class="relative z-[1]">
		@for (item of data; track item.label) {
			<div class="flex w-full flex-col">
				<!-- Grid lines -->
				<div class="flex w-full items-center">
					<!-- Label -->
					<div class="flex h-8 w-56 items-center pr-4 text-xs text-gray-700 lg:w-64 lg:text-sm">
						<div class="line-clamp-2 w-full">
							{{ item.label }}
						</div>
					</div>

					<!-- Bar Background with grid lines -->
					<div class="flex-1 border-b border-[#d9d9d9] py-3">
						<div
							class="relative h-8 overflow-hidden rounded-r-3xl"
							[ngClass]="{
								'bg-[#49A06C]/35': item.value === 5,
								'bg-[#C1E9D2]': item.value === 4,
								'bg-[#FFC738]/15': item.value === 3,
								'bg-[#F9AC51]/15': item.value === 2,
								'bg-[#FFD1D1]': item.value === 1,
								'bg-[#F7F4F4]': item.value === -1,
							}"
						>
							<!-- Colored Bar -->
							<div
								class="h-full rounded-r-3xl transition-all duration-300"
								[ngClass]="{
									'bg-[#49A06C]': item.value === 5,
									'bg-[#52C280]': item.value === 4,
									'bg-[#FFC738]': item.value === 3,
									'bg-[#F9AC51]': item.value === 2,
									'bg-[#FF5151]': item.value === 1,
									'rounded-r-lg bg-[#C1C3C9]': item.value === -1,
								}"
								[style.width.%]="item.value === -1 ? 1 : (item.value / 5) * 100"
							></div>
						</div>
					</div>
				</div>
			</div>
		}
	</div>

	<!-- Rating scale (0 to 5) below -->
	<div class="mt-2"></div>
</div>
